window.$ = (selector, scope = document) => scope.querySelector(selector)
window.$$ = (selector, scope = document) => Array.from(scope.querySelectorAll(selector))
